import { apiSlice } from "../apiSlice";


export interface initialData {
    home: {
        topBanner: {
            imageUrl: string;
            textOverlay: {
                title: string;
                description: string;
            };
        };
        sliderProducts: {
            itemId: string;
            itemType: string;
        }[];
        signatureDishes: {
            displayName: string;
            productId: string;
            price: string;
            description: string;
            imageUrl: string;
            id: string;
            itemType: string;
        }[];
        userReviews: {
            title: string;
            rating: number;
            review: string;
            displayName: string;
        }[];
        newArrivals: {
            id: string;
            itemType: string;
        }[];
    },
    promise: {
        topBanner: {
            imageUrl: string;
            textOverlay: {
                title: string;
                description: string;
            };
        };
        introVideo: string;
    },
    contactInfo: {
        email: string;
        phoneNumber: string;
    }
    menu: {
        specialdishes: {
            displayName: string,
            description: string,
            imageUrl: string,
            id: string,
        }[],
        introVideo: string,
        quickOrder: {
            displayName: string,
            description: string,
            imageUrl: string,
            id: string,
            nutrients: {
                calories: number,
                protein: number,
                carbs: number,
                fat: number
            },
            quickOrderItems?: {
                id: string,
                itemType: string,
                nutrients: {
                    calories: number,
                    protein: number,
                    carbs: number,
                    fat: number
                }
            }[]
        }
    }
};
const INITIAL_DATA_URL = process.env.REACT_APP_INITIAL_DATA_DOMAIN;

export interface userReviewsInterface {
    title: string;
    rating: number;
    review: string;
    displayName: string;
}

export const initialDataService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getInitialData: builder.query<initialData, void>({
            async queryFn(_arg, _queryApi, _extraOptions, _baseQuery) {
                try {
                    const response = await fetch(`${INITIAL_DATA_URL}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                        },
                    });

                    if (!response.ok) {
                        return {
                            error: {
                                status: response.status,
                                data: await response.text(),
                            }
                        };
                    }

                    const data = await response.json();
                    return { data };
                } catch (error: any) {
                    return {
                        error: {
                            status: 'FETCH_ERROR',
                            data: error?.message,
                            error: error?.message || 'Unknown error'
                        }
                    };
                }
            },
            keepUnusedDataFor: 7200,
        }),
    }),
});

export const { useGetInitialDataQuery, useLazyGetInitialDataQuery } = initialDataService;